import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/backend',
    name: 'backend',
    component: () => import(/* webpackChunkName: "backend" */ '../Views/LayoutView.vue'),
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '../Views/DashboardView.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../Views/LoginView.vue'),
  }
]

const Router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default Router;
